module.exports = __webpack_public_path__ + "img/users_menu2_invoiceweb.31ec2aba.png";